import { render, staticRenderFns } from "./TrainingInProgressCard.vue?vue&type=template&id=08840f29&scoped=true"
import script from "./TrainingInProgressCard.vue?vue&type=script&lang=js"
export * from "./TrainingInProgressCard.vue?vue&type=script&lang=js"
import style0 from "./TrainingInProgressCard.vue?vue&type=style&index=0&id=08840f29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08840f29",
  null
  
)

export default component.exports